import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHead, Panel, SButton, sInput, sLabel } from "@/components/staff/Bits";

const FIELDS = ["office_phone", "office_hours", "announcement", "announcement_link", "announcement_until"];
const blank = Object.fromEntries(FIELDS.map((k) => [k, ""]));

const Field = ({ id, label, f, setF, hint, ...rest }) => (
  <div>
    <label className={sLabel} htmlFor={id}>{label}</label>
    <input id={id} data-testid={`settings-${id.replace(/_/g, "-")}`} className={sInput} value={f[id]} onChange={(e) => setF({ ...f, [id]: e.target.value })} {...rest} />
    {hint && <p className="mt-1 text-xs text-[#605349]">{hint}</p>}
  </div>
);

export default function Settings() {
  const [f, setF] = useState(blank);
  useEffect(() => { api.get("/public/settings").then((r) => setF(Object.fromEntries(FIELDS.map((k) => [k, r.data[k] || ""])))).catch(() => {}); }, []);
  const save = async () => {
    try {
      await api.put("/settings", Object.fromEntries(FIELDS.map((k) => [k, f[k].trim() || null])));
      toast.success("Settings saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const p = { f, setF };
  return (
    <div className="max-w-xl space-y-6">
      <PageHead title="Settings" sub="Shown on the public site so people can confirm that a call or message really comes from the parish." />
      <Panel testid="settings-form">
        <div className="space-y-4">
          <Field id="office_phone" label="Official parish office phone number" placeholder="e.g. (083) 000 0000" {...p} />
          <Field id="office_hours" label="Office hours" placeholder="e.g. Tue–Sun, 8:00 AM – 5:00 PM" {...p} />
        </div>
      </Panel>
      <Panel testid="settings-announcement-form">
        <div className="space-y-4">
          <div>
            <p className="font-bold text-[#4A2E1A]">Parish news strip</p>
            <p className="text-sm text-[#605349]">One short line at the top of the homepage, such as Mass times or an upcoming event. Leave empty to hide it.</p>
          </div>
          <Field id="announcement" label="Announcement" maxLength={200} placeholder="e.g. Sunday Masses: 6:00 AM, 8:00 AM and 5:00 PM" hint={`${f.announcement.length}/200 characters`} {...p} />
          <Field id="announcement_link" label="Link for more details (optional)" type="url" placeholder="https://mabuhayparish.org/..." hint="Must start with https://" {...p} />
          <Field id="announcement_until" label="Show until (optional)" type="date" hint="The strip hides itself after this date." {...p} />
        </div>
      </Panel>
      <SButton data-testid="settings-save-button" onClick={save}>Save</SButton>
    </div>
  );
}
